import { useState, useEffect } from 'react'
import LogoProcob from '../../assets/img/svg/logoProcob'
import SearchInput from '../inputs/searchInput'
import ButtonContained from '../buttons/buttonContained'
import { Collapse, Slide } from '@mui/material'
import { Close, Language, Search } from '@mui/icons-material'
import {
  StyledGrid,
  StyledContainer,
  StyledGroupSearchResponsive,
  StyledButtonSearchClose,
  StyledDivActions,
  StyledButtonSearch,
  StyledHeaderContent,
  StyledHeaderLocale,
  StyledHeaderLogoLocale
} from './styles'
import useMediaResponsive from '../../assets/styles/mediaQuery'
import stores from '../../stores/store'
import { Link, useLocation } from 'react-router-dom'
import { SearchHeader } from './search'
import Navbar from '../navbar'

export default function Header() {
  const {
    localeSelected,
    setLocale,
    setJsonSelected,
    jsonSelected: lang
  } = stores.DataLocaleStore()
  const { setClearContentRequested } = stores.DataContentRequestedStore()
  const { hideHeader } = stores.DataHideHeaderStore()
  const {
    maxMedia900,
    maxMedia800,
    maxMedia600,
    maxMedia450,
    maxMedia420,
    maxMedia1250
  } = useMediaResponsive()
  const [showSearchInput, setShowSearchInput] = useState(false)
  const [hideElements, setHideElements] = useState(false)
  const [buttonText, setButtonText] = useState(lang.header.signIn)
  const [isCampaignMode, setIsCampaignMode] = useState(false)
  const [isPageThanks, setIsPageThanks] = useState(false)
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search).toString()

  const handleClick = () => {
    setLocale(localeSelected === 'PT' ? 'EN' : 'PT')
    setClearContentRequested()
  }

  const handleSearchClick = () => {
    setShowSearchInput(!showSearchInput)
  }

  useEffect(() => {
    if (showSearchInput) {
      setHideElements(false)
    } else {
      let timer: NodeJS.Timeout

      if (maxMedia800) {
        timer = setTimeout(() => setHideElements(true), 1)
      } else {
        timer = setTimeout(() => setHideElements(true))
      }
      return () => clearTimeout(timer)
    }
  }, [showSearchInput, maxMedia800])

  useEffect(() => {
    setJsonSelected(localeSelected)
  }, [localeSelected])

  useEffect(() => {
    const currentUrl = window.location.href
    const hasPathThanks = currentUrl.includes('/obrigado')
    const hasCampaignParam =
      currentUrl.includes('?campanha001') || currentUrl.includes('&campanha001')

    if (hasPathThanks) {
      setButtonText(lang.header.test)
      setIsPageThanks(true)
    } else {
      if (hasCampaignParam) {
        setButtonText(lang.header.contact)
        setIsCampaignMode(true)
      } else {
        setButtonText(lang.header.signIn)
        setIsCampaignMode(false)
      }
    }
  }, [location, lang])

  function redirectLogin() {
    if (isPageThanks) {
      window.location.href = 'https://cadastro.procob.com/'
    } else {
      if (isCampaignMode) {
        window.location.href = 'https://www.procob.com/comercialprocob/'
      } else {
        window.location.href = `${process.env.REACT_APP_API_CONSULTA}/docs`
      }
    }
  }

  const ContentStyleGrid = () => {
    return (
      <StyledGrid container>
        <StyledContainer>
          <Slide
            direction="left"
            in={showSearchInput}
            mountOnEnter
            unmountOnExit
          >
            <StyledGroupSearchResponsive>
              <SearchHeader />
              <StyledButtonSearchClose onClick={handleSearchClick}>
                <Close />
              </StyledButtonSearchClose>
            </StyledGroupSearchResponsive>
          </Slide>
          <StyledHeaderContent
            style={{ display: !hideElements ? 'none' : 'flex' }}
          >
            <StyledHeaderLogoLocale>
              <Link to={queryParams ? `/?${queryParams}` : '/'}>
                <LogoProcob size={maxMedia600 ? 'md' : 'lg'} />
              </Link>
              <StyledHeaderLocale onClick={handleClick}>
                <Language />
                {localeSelected}
              </StyledHeaderLocale>
            </StyledHeaderLogoLocale>
            <StyledDivActions>
              {maxMedia800 ? (
                <StyledButtonSearch onClick={handleSearchClick}>
                  <Search />
                </StyledButtonSearch>
              ) : (
                <SearchHeader />
              )}
              <ButtonContained
                onClick={redirectLogin}
                size="lg"
                text={buttonText}
              />
            </StyledDivActions>
          </StyledHeaderContent>
        </StyledContainer>
        {maxMedia1250 && <Navbar />}
      </StyledGrid>
    )
  }

  return (
    <>
      {maxMedia900 ? (
        <ContentStyleGrid />
      ) : (
        <Collapse in={!hideHeader}>
          <ContentStyleGrid />
        </Collapse>
      )}
    </>
  )
}
